import { MergeTagNode } from "./MergeTagNode"

// eslint-disable-next-line import/prefer-default-export
export const createMergeTagEditorConfig = (namespace: string) => ({
  namespace,
  nodes: [MergeTagNode],
  onError: (error: Error) => { throw error },
  theme: {},
  editable: true,
})
